import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const IndiaEntryEntityStructuring = () => {
  const serviceData = {
    title: "India Entry & Entity Structuring",
    heading: "India Entry & Entity Structuring",
    image: subTopicImages["India Entry & Entity Structuring"],
    intro:
      "Helping global companies select the right structure for their India business",
    description: [
      "Choosing the right legal structure is the foundation of a successful India entry strategy. The decision impacts taxation, operational flexibility, ownership control, funding plans, compliance cost and risk exposure.",
      "At V DOOGAR AND ASSOCIATES, we advise foreign companies on the most suitable entity structure for their India operations — ensuring it aligns with both business objectives and regulatory requirements. Our team evaluates your global structure, business model, industry regulations, and tax implications before recommending the right setup approach.",
      "We support investors across industries, including manufacturing, trading, technology, services, sourcing, R&D and more.",
    ],
    services: [
      {
        title: "Entity Evaluation & Structuring",
        text: "We assess suitable legal options based on business needs, including:",
        list: [
          "Private Limited Company",
          "Limited Liability Partnership (LLP)",
          "Branch Office",
          "Liaison Office",
          "Project Office",
          "Joint Venture Entity",
        ],
        extraInfo:
          "We review implications relating to taxation, repatriation, FEMA investment rules, liability and governance, operational control, and ongoing compliance cost to design a structure that supports long-term growth.",
      },
      {
        title: "Shareholding & Capital Structuring",
        text: "We assist in designing appropriate:",
        list: [
          "ownership patterns",
          "capitalisation plans",
          "funding routes",
          "equity vs debt planning",
          "pricing & valuation considerations",
        ],
        extraInfo:
          "Ensuring compliance with Indian regulations and foreign investment guidelines.",
      },
      {
        title: "Group & Control Framework Design",
        text: "We support:",
        list: [
          "board constitution",
          "shareholder agreements",
          "management control framework",
          "compliance delegation design",
        ],
        extraInfo: "So that governance remains structured and transparent.",
      },
    ],
    benefitsIntro: "How we add value to your India entry strategy:",
    benefits: [
      "Strategically structured India presence",
      "Clear legal & regulatory positioning",
      "Alignment with global group structure",
      "Long-term tax and compliance efficiency",
      "Risk-managed set-up approach",
    ],
    research:
      "Our India Entry team combines tax, legal, FEMA and corporate advisory expertise — ensuring every structure we recommend is commercially viable, compliant and future-ready.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default IndiaEntryEntityStructuring;
